// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p7Os","importantInfo":"styles_importantInfo__3cXPF"};